import { getContext } from '@fiverr-private/fiverr_context';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Store } from '../types';

type ProcessedReferrerState = ReturnType<typeof getProcessedState>;

const getProcessedState = () => {
    const { referrer } = getContext();

    return {
        [MIXPANEL_EVENT_PROPERTIES.REFERRER_URL]: referrer,
        [MIXPANEL_EVENT_PROPERTIES.REFERRER]: referrer,
    };
};

export class ReferrerStore implements Store<ProcessedReferrerState> {
    public getData = () => getProcessedState();
}
